module.exports = __webpack_public_path__ + "img/skills-summon-nec-1.b9c0d1e4.png";